import http from "@/utils/request";
import qs from 'qs'
/**
 * 登录接口
 * @param {*} params 
 * @returns 
 */
export function login(params) {
  return http.post("/login", params);
}

// 获取用户详细信息
export function getUserInfo() {
  return http.get('/getInfo')
}

// 获取用户详细信息
export function updateUserPwd(params) {
  return http.put('/system/user/profile/updatePwd?' + qs.stringify(params))
}


// 退出方法
export function logout() {
  return http.post('/logout')
}

// 获取验证码
export function getCodeImg() {
  return http.get('/captchaImage', {}, {isToken: false})
}